import { Box, Grid } from '@mui/material';
import KheopsLogo from '../assets/logo/kheopsLogo.svg?react';
import HeroImage from '../assets/photos/bg-fruits.png';
import { useRedirectIfAuth } from '../hooks/useRedirectIfAuth';
import LoginForm from './LoginForm';

export default function LoginPage(): React.JSX.Element {
  const RedirectIfAuth = useRedirectIfAuth();

  return (
    <RedirectIfAuth>
      <Grid container sx={{ backgroundColor: 'surface.main' }}>
        <Grid
          size={{ xs: 7 }}
          sx={{
            position: 'sticky',
            height: '100vh',
            top: 0,
            borderBottomRightRadius: '148px',
            overflow: 'hidden',
            display: {
              xs: 'none',
              sm: 'flex',
            },
          }}
        >
          <Box component="img" src={HeroImage} sx={{ minWidth: '100%', objectFit: 'cover' }} />
        </Grid>
        <Grid
          container
          size={{ xs: 12, sm: 5 }}
          sx={{
            flexDirection: 'column',
            paddingTop: 11.5,
            flexWrap: 'nowrap',
            backgroundColor: 'surface.main',
            height: '100vh',
          }}
        >
          <Grid sx={{ textAlign: 'center', mb: 0, flex: 'none' }}>
            <Box component={KheopsLogo} sx={{ height: 68, width: 'auto' }} />
          </Grid>
          <Grid sx={{ display: 'flex', justifyContent: 'center' }}>
            <LoginForm />
          </Grid>
        </Grid>
      </Grid>
    </RedirectIfAuth>
  );
}
